import React from "react";
import { Helmet } from "react-helmet";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import { comapnyCtaContent, hireMachineLearning } from "../data/hire-machine-learning";
import HirePageTestimonial from "../components/hire-page-testimonial/HirePageTestimonial";
import NewTeamSection from "../components/new-team-section/NewTeamSection";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import ChallengeSection from "../components/challenge-section/ChallengeSection";
import HirePageSolutionSection from "../components/hire-page-solution-section/HirePageSolutionSection";
import NewCtaSection from "../components/new-cta-section/NewCtaSection";

const HIreMachineLearning = () => {

    return (
        <>
            <Helmet>
                <title>Hire Machine Learning Engineers | Bitsclan Best AI/ML Developers</title>
                <meta name="description" content="Hire proven machine learning engineers in the USA for AI, automation & predictive analytics. Bitsclan’s skilled AI/ML developers deliver reliable, enterprise-grade ai & ml solutions." />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={hireMachineLearning?.mainBanner?.shortHeading}
                mainHeading={hireMachineLearning?.mainBanner?.mainHeading}
                description={hireMachineLearning?.mainBanner?.content}
            />
            <TrustedPartner heading="Trusted & Partnered by Businesses Worldwide to Build High Performance Machine Learning Solutions" />

            <OurServices
                shortHeading={hireMachineLearning?.flutterExpertise?.shortHeading}
                mainHeading={hireMachineLearning?.flutterExpertise?.heading}
                description={hireMachineLearning?.flutterExpertise?.description}
                servicesCardsData={hireMachineLearning?.flutterExpertise?.servicesData}
                buttonText="Start Your ML Project"
            />

            <HirePageTestimonial
                shortHeading="Some of Our Happy Clients"
                mainHeading="Trusted Partnerships. Proven <span>Machine Learning</span> Engineering Excellence"
                description="Clients choose our Machine Learning engineers not just for the solutions we deliver, but for their expertise, transparency, and proactive approach. Our engineers design scalable, efficient solutions that drive long-term success and business transformation."
                testimonials={hireMachineLearning?.testimonialsData}
            />

            <NewTeamSection
                shortHeading={"Our Team"}
                mainHeading={"Introducing Our Expert Machine Learning Team"}
                description={"Our specialized Machine Learning engineers expertly handle every stage, from data engineering to model deployment, delivering scalable solutions that drive impactful business results."}
            />

            <NewCtaSection content={hireMachineLearning?.ctaSection} />

            {/* <NewTestimonials
                shortHeading=" Some of Our Happy Clients"
                mainHeading="What Our Clients Say About Bitsclan's <span>Flutter Expertise</span>"
                description="We take pride in our flutter app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
            /> */}

            <NewCaseStudySection
                shortHeading="Our Clients Journey"
                heading="Driving Business Transformation Through Machine Learning Innovation"
                description="Explore how our Machine Learning engineers empower businesses, drive innovation, and deliver measurable success through custom-built models and scalable AI solutions that transform data into strategic, actionable insights across industries."
            />

            {/* <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs.heading}
        greenHeading={whyChooseUs.greenHeading}
        subHeading={whyChooseUs.subHeading}
        solutions={whyChooseUs.solutionsData}
      /> */}

            <HireCombinationSection
                shortHeading={hireMachineLearning?.techCombinations?.shortHeading}
                combinations={hireMachineLearning?.techCombinations?.combinations}
                heading={hireMachineLearning?.techCombinations?.heading}
                description={hireMachineLearning?.techCombinations?.description}
            />

            <WhyChooseBitsclan
                tabs={hireMachineLearning?.whyChooseBitsclanContet}
                expandAllAccordions={true}
                shortHeading={"How We Work"}
                heading={"Here’s why leading companies trust us with our DevOps teams"}
                subheading={"From infrastructure automation to continuous integration, we’ve perfected every stage of our process to deliver exceptional results. <br/> <br/> Our approach guarantees transparency, speed, and quality, helping you build scalable systems faster. With us, you get a reliable DevOps partner focused on performance, efficiency, and measurable success."}
                ctaText={"Contact Our Experts"}
            />

            <SimpleModels content={hireMachineLearning?.engagementModels} />

            <CoverTheStack
                shortHeading={hireMachineLearning?.coverTheStack?.shortHeading}
                whereStart={hireMachineLearning?.coverTheStack.whereStart}
                mainHeading={hireMachineLearning?.coverTheStack.mainHeading}
                subHeading={hireMachineLearning?.coverTheStack.subHeading}
                tabs={hireMachineLearning?.coverTheStack.tabs}
                tabItems={hireMachineLearning?.coverTheStack.tabItems}
            />

            <HirePageSteps
                buttonText={hireMachineLearning?.hireSteps.btnText}
                heading={hireMachineLearning?.hireSteps.heading}
                subHeading={hireMachineLearning?.hireSteps.subHeading}
                steps={hireMachineLearning?.hireSteps.steps}
            />

            <ChallengeSection
                mainHeading={"Top Challenges in Machine Learning Hiring & Development"}
                description={""}
                content={hireMachineLearning?.challengesData}
            />

            <HirePageSolutionSection
                shortHeading="Machine Learning Solutions We Build"
                mainHeading="How We Solve Machine Learning Hiring & Development Challenges"
                description="We simplify the process of hiring, managing, and scaling ML engineering teams. Our approach tackles every challenge from recruitment to deployment ensuring that your projects move seamlessly from concept to production with measurable success."
                content={hireMachineLearning?.mlSolutionsData}
            />

            <WhyChooseUs
                heading={hireMachineLearning?.whyUsContent?.heading}
                greenHeading={hireMachineLearning?.whyUsContent?.greenHeading}
                shortHeading={hireMachineLearning?.whyUsContent?.shortHeading}
                content={hireMachineLearning?.whyUsContent?.content}
                stats={hireMachineLearning?.whyUsContent?.stats}
                cta={hireMachineLearning?.whyUsContent?.cta}
                sectionImage={hireMachineLearning?.whyUsContent?.image}
            />

            {/* <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts.heading}
        greenHeading={expertFacts.greenHeading}
        facts={expertFacts.facts}
        diffBannerBackgroundImage={expertFacts.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection?.heading}
        content={appIdeaSection.content}
      /> */}

            {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels.headingContent}
        content={hirePageEngagementModels.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

            {/* <SimpleModels content={engagementModelsContent} /> */}

            <TrendsInsights heading="Only show blogs related to AI/ML" description="Here’s the revised version of the Machine Learning FAQs section, with the word 'hire' replaced and the content focused on business impact" specificClass="mobile-dev-page" category="all" />

            <SecondFaq
                specificClass="mobile-dev-page"
                faqs={hireMachineLearning?.faqSection.faqData}
                mainHeading={hireMachineLearning?.faqSection.mainHeading}
                subHeading={hireMachineLearning?.faqSection.subHeading}
            />

            {/* <ContactSection /> */}

            <SoftwareCompanyCta content={comapnyCtaContent} />

            <Footer />
        </>
    );
};

export default HIreMachineLearning;